/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { DeleteCompuweighRequest } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class CompuweighMassDeletes<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name DeleteCompuweigh
   * @request POST:/compuweigh-mass-deletes
   * @secure
   */
  deleteCompuweigh = (data: DeleteCompuweighRequest, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/compuweigh-mass-deletes`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsCompuweighMassDeletes
   * @request OPTIONS:/compuweigh-mass-deletes
   */
  optionsCompuweighMassDeletes = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/compuweigh-mass-deletes`,
      method: 'OPTIONS',
      ...params,
    });
}
